import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import userImage from "../assets/user.jpg";
import { hasPermission, clearPermissionsCache } from "../utils/permissions";

function Header() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  // const [patients, setPatients] = useState([]);
  // const [filteredPatients, setFilteredPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [searchResults, setSearchResults] = useState([]);
  const [permLoading, setPermLoading] = useState(true);
  const [canSeeAgeingSearch, setCanSeeAgeingSearch] = useState(false);
const [results, setResults] = useState([]);
const [masterResults, setMasterResults] = useState([]);
// const [results, setResults] = useState([]);
const [activeIndex, setActiveIndex] = useState(-1);
const itemRefs = useRef([]);


  const [canEditCompany, setCanEditCompany] = useState(false);
  const [userName, setUserName] = useState("");
  const searchRef = useRef(null);
  const dropdownRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
useEffect(() => {
  setActiveIndex(-1);
  itemRefs.current = [];
}, [results]);

  // Load logged-in user name
  useEffect(() => {
    const userDataStr = localStorage.getItem("user_data");
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        setUserName(userData.user?.user_name || userData.user_name || "User");
      } catch (e) {
        setUserName("User");
      }
    }
  }, []);

  // ✅ Reset search when route changes
useEffect(() => {
  setSearchTerm("");
  setShowDropdown(false);
  fetchPatients("");   // ✅ restore list
}, [location.pathname]);



useEffect(() => {
  let isMounted = true;
  (async () => {
    try {
      const allowed = await hasPermission("folders", "ageingsearch"); // ✅ FOLDER LEVEL
      if (isMounted) setCanSeeAgeingSearch(!!allowed);
    } catch (e) {
      if (isMounted) setCanSeeAgeingSearch(false);
    }
  })();
  return () => { isMounted = false; };
}, []);

  // ✅ Load permission for company settings (profile.profile)
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const allowed = await hasPermission("profile", "profile");
        if (isMounted) setCanEditCompany(!!allowed);
      } catch (e) {
        if (isMounted) setCanEditCompany(false);
      } finally {
        if (isMounted) setPermLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  // ✅ Logout
  const handleLogout = async () => {
    try {
      const sessionToken = localStorage.getItem("session_token");
      const res = await fetch("https://newerp.awasthivitality.com/api/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${sessionToken || ""}`,
        },
      });

      // Always clear local data
      // clearPermissionsCache?.();
      // localStorage.removeItem("session_token");
      // localStorage.removeItem("user_data");
      // sessionStorage.clear();
clearPermissionsCache?.();
      localStorage.removeItem("session_token");
      localStorage.removeItem("user_data");
      localStorage.removeItem("auto_logout_minutes");
      localStorage.removeItem("session_last_activity_at");
      sessionStorage.removeItem("session_logout_reason");
      sessionStorage.clear();
      toast.info("Logged out successfully!", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });

      navigate("/", { replace: true });
    // } catch (error) {
    //   console.error("Logout error:", error);
    //   localStorage.removeItem("session_token");
    //   localStorage.removeItem("user_data");
    //   sessionStorage.clear();
} catch (error) {
      console.error("Logout error:", error);
      localStorage.removeItem("session_token");
      localStorage.removeItem("user_data");
      localStorage.removeItem("auto_logout_minutes");
      localStorage.removeItem("session_last_activity_at");
      sessionStorage.removeItem("session_logout_reason");
      sessionStorage.clear();
      toast.error("Something went wrong during logout!", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
      navigate("/", { replace: true });
    }
  };

  // ✅ Fetch Notifications
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoadingNotifications(true);
        const sessionToken = localStorage.getItem("session_token");
        if (!sessionToken) {
          navigate("/", { replace: true });
          return;
        }

        const res = await fetch(
          "https://newerp.awasthivitality.com/api/dashboard/recent-activities",
          {
            headers: {
              "X-Session-Token": sessionToken,
            },
          }
        );

        if (res.status === 401) {
          localStorage.removeItem("session_token");
          localStorage.removeItem("user_data");
          navigate("/", { replace: true });
          return;
        }

        const data = await res.json();
        if (data.success && Array.isArray(data.data)) {
          const patientNotifs = data.data.filter(
            (item) =>
              item.activity_type?.toLowerCase().includes("patient") ||
              item.title?.toLowerCase().includes("patient") ||
              item.message?.toLowerCase().includes("patient")
          );
          setNotifications(patientNotifs);
        } else {
          setNotifications([]);
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setNotifications([]);
      } finally {
        setLoadingNotifications(false);
      }
    };
    fetchNotifications();
  }, [navigate]);
const handleKeyDown = (e) => {
  if (!showDropdown || results.length === 0) return;

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < results.length - 1 ? prev + 1 : 0
      );
      break;

    case "ArrowUp":
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : results.length - 1
      );
      break;

    case "Enter":
      e.preventDefault();
      if (activeIndex >= 0 && results[activeIndex]) {
        handlePatientSelect(results[activeIndex]);
      }
      break;

    case "Escape":
      setShowDropdown(false);
      break;

    default:
      break;
  }
};

  // ✅ Helper: parse input like "lead test", "patient: ankit", "branch Delhi"
  const parseSearchInput = (raw) => {
    const v = (raw || "").trim();
    const m = v.toLowerCase().match(/^(lead|patient|branch)[:\s]+(.*)$/);
    if (m) {
      return { type: m[1], term: (m[2] || "").trim() };
    }
    if (["lead", "patient", "branch"].includes(v.toLowerCase())) {
      return { type: v.toLowerCase(), term: "" };
    }
    return { type: null, term: v };
  };

  const extractTextAndNumber = (value = "") => {
  const text = value.replace(/\d+/g, "").trim().toLowerCase();
  const numberMatch = value.match(/\d+/);
  return {
    text,
    number: numberMatch ? numberMatch[0] : null,
  };
};
useEffect(() => {
  if (activeIndex >= 0 && itemRefs.current[activeIndex]) {
    itemRefs.current[activeIndex].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }
}, [activeIndex]);

const fetchPatients = async (query = "") => {
  try {
    setLoading(true);
    const sessionToken = localStorage.getItem("session_token");

    const parsed = parseSearchInput(query);

    const response = await fetch(
      `https://newerp.awasthivitality.com/api/dashboard/master-search?q=${encodeURIComponent(parsed.term || "")}`,
      {
        headers: {
          "X-Session-Token": sessionToken,
        },
      }
    );

    const data = await response.json();
if (data.success && Array.isArray(data.data)) {
  let finalData = data.data;

  if (parsed.type) {
    finalData = finalData.filter(item => item.type === parsed.type);
  }

  // 🔥 SMART SORTING LOGIC
  const { text, number } = extractTextAndNumber(query);

  finalData = finalData.sort((a, b) => {
    const aName = (a.name || "").toLowerCase();
    const bName = (b.name || "").toLowerCase();

    const aId = String(a.patient_id || a.lead_id || "");
    const bId = String(b.patient_id || b.lead_id || "");

    // 1️⃣ Exact ID match
    if (number) {
      if (aId === number && bId !== number) return -1;
      if (bId === number && aId !== number) return 1;
    }

    // 2️⃣ Name + ID match
    if (text && number) {
      const aCombo = aName.includes(text) && aId.includes(number);
      const bCombo = bName.includes(text) && bId.includes(number);
      if (aCombo && !bCombo) return -1;
      if (bCombo && !aCombo) return 1;
    }

    // 3️⃣ Name match only
    if (text) {
      if (aName.includes(text) && !bName.includes(text)) return -1;
      if (bName.includes(text) && !aName.includes(text)) return 1;
    }

    return 0;
  });

  setResults(finalData);
}
 else {
      setResults([]);
    }
  } catch (err) {
    console.error("Search error", err);
    setResults([]);
  } finally {
    setLoading(false);
  }
};



  // ✅ Load initial list
 useEffect(() => {
  fetchPatients(""); // recent only
}, []);


  // ✅ Debounced search handler
const handleSearchChange = (e) => {
  const value = e.target.value;
  setSearchTerm(value);
  setShowDropdown(true);

  if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

  searchTimeoutRef.current = setTimeout(() => {
    fetchPatients(value); // 🔥 call API with keyword
  }, 300);
};




  // ✅ Handle select for all entity types
// ✅ Handle select for all entity types
  const handlePatientSelect = (item) => {
    // Set search term to display_text from your JSON (e.g., "#9 - test - 9876543210")
    setSearchTerm(item.display_text || item.name || "");
    setShowDropdown(false);
    
    // Use the redirect_url provided in your JSON if available, else fallback to manual routing
    if (item.redirect_url) {
      navigate(item.redirect_url);
    } else if (item.type === 'lead') {
      navigate(`/LeadDetails/${item.lead_id}`);
    } else if (item.type === 'branch') {
      navigate(`/branch/${item.branch_id}`);
    } else {
      navigate(`/patient/details/${item.patient_id}`);
    }
  };
  // ✅ Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        searchRef.current &&
        !searchRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ===============================
  // ✅ UI Section
  // ===============================
  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "#fff",
        padding: "12px 20px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        position: "relative",
      }}
    >
      {/* Logo */}
      <div>
        <img
          src={userImage}
          alt="logo"
          style={{
            width: "40px",
            height: "40px",
            objectFit: "cover",
            display: "none",
            cursor: "pointer",
            borderRadius: "50%",
          }}
          onClick={() => navigate("/dashboard")}
        />
      </div>
{/* Ageing Search – Only if permission */}
{canSeeAgeingSearch && (
  <button
    onClick={() => navigate("/AgeingSearch")}
    style={{
      padding: "8px 14px",
      borderRadius: "6px",
      border: "1px solid #007bff",
      background: "#0dcaf0",
      color: "#fff",
      cursor: "pointer",
      fontSize: "14px",
      whiteSpace: "nowrap",
      minWidth: "120px",
      transition: "all 0.3s",
    }}
    className="responsive-ageing-btn"
  >
    Ageing Search
  </button>
)}

<style jsx>{`
  @media (max-width: 768px) {
    header {
      flex-direction: column;       /* Stack items vertically */
      align-items: stretch;
      gap: 10px;                     /* Add spacing between elements */
    }

    .responsive-ageing-btn {
      width: 100%;                   /* Full width button on mobile */
      font-size: 13px;               /* Slightly smaller text */
      padding: 10px;                 /* Adjust padding */
      white-space: normal;           /* Allow text wrap */
    }

    input {
      font-size: 14px;               /* Slightly smaller input text */
    }

    div[ref*="searchRef"] {
      width: 100% !important;        /* Search bar full width */
      max-width: 100% !important;
    }
  }
`}</style>

<style jsx>{`
  @media (max-width: 768px) {
    .responsive-ageing-btn {
      width: 100%;       /* Full width on mobile */
      font-size: 13px;   /* Slightly smaller text */
      padding: 10px;     /* Adjust padding */
      white-space: normal; /* Allow text wrap if needed */
    }
  }
`}</style>


      {/* 🔍 Search Bar */}
      <div ref={searchRef} style={{ position: "relative", width: "400px", maxWidth: "50%" }}>
        <input
          type="text"
          placeholder="Search patients, leads, branches by name, ID, mobile, ..."
          value={searchTerm}
          onChange={handleSearchChange}
          onFocus={() => setShowDropdown(true)}
            onClick={() => setShowDropdown(true)}   // ✅ ADD THIS LINE
  onKeyDown={handleKeyDown}

          style={{
            width: "100%",
            padding: "10px 36px 10px 12px",
            border: "2px solid #ddd",
            borderRadius: "8px",
            fontSize: "15px",
            outline: "none",
            transition: "border 0.3s",
          }}
        />
        <span
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#666",
            fontSize: "16px",
          }}
        >
          {loading ? "⏳" : "🔍"}
        </span>

        {showDropdown && (
          <div
            ref={dropdownRef}
            style={{
              position: "absolute",
              top: "105%",
              left: 0,
              right: 0,
              background: "white",
              border: "1px solid #ddd",
              borderTop: "none",
              borderRadius: "0 0 8px 8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              zIndex: 1000,
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
{loading ? (
  <div style={{ padding: "12px", textAlign: "center", color: "#888" }}>Loading...</div>
) : results.length > 0 ? (
  results.map((item, index) => {
    const isLead = item.type === "lead";
    const isBranch = item.type === "branch";
    const isPatient = item.type === "patient" || (!isLead && !isBranch);
  const isActive = index === activeIndex;

    return (
      <div
        key={index}
              ref={(el) => (itemRefs.current[index] = el)}

        onClick={() => handlePatientSelect(item)}
        style={{
           padding: "10px",
        cursor: "pointer",
        borderBottom: "1px solid #eee",
        backgroundColor: isActive ? "#e9f2ff" : "white",
        outline: isActive ? "2px solid #007bff" : "none",

        }}
        
             onMouseEnter={() => setActiveIndex(index)}

      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Label Badge */}
          <span style={{
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "10px",
            fontWeight: "bold",
            background: isLead ? "#ffc107" : isBranch ? "#17a2b8" : "#007bff",
            color: "#fff",
          }}>
            {item.type?.toUpperCase()}
          </span>
          {/* Use the 'name' key from your JSON */}
          <span style={{ fontWeight: "bold", color: "#333" }}>
            {item.name || "N/A"}
          </span>
        </div>

        {/* Use mobile and id keys from your JSON */}
        <div style={{ fontSize: "13px", color: "#666", marginTop: "4px" }}>
          {isLead && (
            <>ID: {item.lead_id} |Name: {item.name || "N/A"} | Mobile: {item.mobile || "N/A"} </>
          )}
          {isPatient && (
            <>Patient ID: {item.patient_id} | Mobile: {item.mobile || "N/A"} | City: {item.city || "N/A"}</>
          )}
          {isBranch && (
            <>Branch: {item.branch_name || "N/A"}</>
          )}
        </div>
      </div>
    );
  })
) : searchTerm.trim() ? (
  <div style={{ padding: "12px", textAlign: "center", color: "#888" }}>
    No results found for "{searchTerm}"
  </div>
) : null}

          </div>
        )}
      </div>

      {/* 🔔 Notifications + Profile + Logout */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <div style={{ position: "relative" }}>
          <span
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              background: "#00bfff",
              color: "#fff",
              fontSize: "10px",
              padding: "2px 5px",
              borderRadius: "50%",
            }}
          >
            {notifications.length}
          </span>
          <i
            className="fas fa-bell"
            style={{ fontSize: "18px", color: "#888", cursor: "pointer" }}
            onClick={() => setShowNotifications((prev) => !prev)}
          ></i>
          {showNotifications && (
            <div
              style={{
                position: "absolute",
                top: "28px",
                right: "0",
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderRadius: "6px",
                overflow: "hidden",
                width: "250px",
                zIndex: 100,
              }}
            >
              {loadingNotifications ? (
                <div style={{ padding: "10px", textAlign: "center" }}>
                  Loading...
                </div>
              ) : notifications.length > 0 ? (
                notifications.map((note, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #eee",
                      fontSize: "13px",
                      color: "#333",
                    }}
                  >
                    <strong>{note.title || "Patient Update"}</strong>
                    <div style={{ fontSize: "12px", color: "#666" }}>
                      {note.message || ""}
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#aaa",
                        marginTop: "4px",
                      }}
                    >
                      {note.activity_time || ""}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    padding: "10px",
                    fontSize: "14px",
                    color: "#999",
                  }}
                >
                  No patient notifications
                </div>
              )}
            </div>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}>
            {userName}
          </span>
          <img
            src={userImage}
            alt="profile"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              objectFit: "cover",
              cursor: "pointer",
            }}
            onClick={() => {
              if (permLoading) {
                toast.info("Checking permission...", { autoClose: 1200 });
                return;
              }
              if (canEditCompany) {
                navigate("/profile");
              } else {
                toast.warn("View only: you do not have permission to edit company settings.", { autoClose: 2000 });
                navigate("/Profile");
              }
            }}
            title={canEditCompany ? "Company Settings" : "Profile (view-only)"}
          />
        </div>

        <i
          className="fas fa-sign-out-alt"
          style={{ fontSize: "18px", color: "#888", cursor: "pointer" }}
          onClick={handleLogout}
          title="Log Out"
        ></i>
      </div>
    </header>
  );
}

export default Header;